export function isOverdue(task) {
  if (task.status === "Done") return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(task.due_date);
  due.setHours(0, 0, 0, 0);
  return due < today;
}

export const STATUS_LABEL = {
  Pending: "Pending",
  "In-Progress": "In Progress",
  Done: "Done",
};

export const PRIORITY_LABEL = {
  Low: "Low",
  Medium: "Medium",
  High: "High",
};

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}
